import React, { useContext, useEffect } from 'react';
import { Heading } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import CustomTagContext from 'hooks/useCustomTag';
import ListTags from 'components/ListTags';
import AddBtn from 'components/AddBtn';
import FormCustomTag from 'components/FormCustomTag';
import Pagination from 'components/Pagination';
import { getTags } from './reqs';
import * as S from './styles';

export default function CustomTag() {
  const { t } = useTranslation();
  const {
    setTags,
    setIsReq,
    setIsFormOpen,
    isFormOpen,
    setPagesData,
    pagesData,
  } = useContext(CustomTagContext);

  useEffect(() => {
    (async () => {
      setIsReq(true);
      await getTags(setTags, setPagesData);
      setIsReq(false);
    })();
  }, []);

  return (
    <S.container>
      <S.title>{t('customTags.title')}</S.title>

      <S.box>
        <AddBtn
          textBtn={t('customTags.addTag')}
          functionToExecOnclick={() => setIsFormOpen(value => !value)}
        />

        <ListTags />

        <S.boxPagination>
          <Pagination
            total={pagesData.total}
            current={pagesData.page}
            perPage={pagesData.limit}
            onPageChange={async position => {
              setPagesData(item => ({ ...item, page: position }));
              await getTags(setTags, setPagesData, position);
            }}
          />
        </S.boxPagination>
      </S.box>

      {isFormOpen && <FormCustomTag />}
    </S.container>
  );
}
